import MuiMenu from '@mui/material/Menu';
import type { ReactNode } from 'react';

interface Origin {
  vertical: 'top' | 'center' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
}

export interface MenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  anchorOrigin?: Origin;
  transformOrigin?: Origin;
  children?: ReactNode;
}

export function Menu({
  anchorEl,
  open,
  onClose,
  anchorOrigin,
  transformOrigin,
  children,
}: MenuProps) {
  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      {...(anchorOrigin !== undefined ? { anchorOrigin } : {})}
      {...(transformOrigin !== undefined ? { transformOrigin } : {})}
    >
      {children}
    </MuiMenu>
  );
}
